exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".separator{margin:0 15px}.container-toggle{position:absolute;top:50%;right:30px;margin-top:-10px;display:block;cursor:pointer}.container-toggle span{color:#9e9b9c;font-size:18px}.container-toggle .selected{color:#fff}@media (max-width:400px){.separator{margin:0 5px}.container-toggle{position:absolute;top:50%;right:15px;margin-top:-9px;display:block;cursor:pointer}.container-toggle span{color:#9e9b9c;font-size:15px}.container-toggle .selected{color:#fff}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-d263e24a","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/shared/SwitchLocale.vue
// module id = 183
// module chunks = 0